import { render, staticRenderFns } from "./servicerMessage.vue?vue&type=template&id=644e0afb&scoped=true"
import script from "./servicerMessage.vue?vue&type=script&lang=js"
export * from "./servicerMessage.vue?vue&type=script&lang=js"
import style0 from "./servicerMessage.vue?vue&type=style&index=0&id=644e0afb&prod&lang=css"
import style1 from "./servicerMessage.vue?vue&type=style&index=1&id=644e0afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e0afb",
  null
  
)

export default component.exports